import { makeStyles } from '@material-ui/core/styles';
import { pxToRem } from '../../../../styles/themes/vad/constants';

const useStyles = makeStyles(theme => ({
  root: {
    ...theme.shape.componentSpacing,
  },
  carouselRoot: {
    '&.MuiGrid-root': {
      marginRight: 0,
      marginLeft: 0,
    }
  },
  title: {
    paddingBottom: pxToRem(40),
    [theme.breakpoints.up('lg')]: {
      paddingBottom: pxToRem(80),
    },
  },
  description: {
    color: theme.palette.text.darkGrey,
    paddingTop: pxToRem(40),
    paddingBottom: pxToRem(28),
    [theme.breakpoints.up('lg')]: {
      paddingTop: pxToRem(80),
      paddingBottom: pxToRem(69),
    },
  },
  author: {
    [theme.breakpoints.up('lg')]: {
      paddingBottom: pxToRem(8),
    },
  },
  authorDesignation: {
    color: theme.palette.common.UnselectedColor,
    paddingBottom: theme.spacing(4),
    [theme.breakpoints.up('lg')]: {
      paddingBottom: theme.spacing(5),
    },
  },
  quoteIcon: {
    display: 'block',
    marginBottom: pxToRem(15),

    '& svg': {
      height: pxToRem(40),
      width: pxToRem(54),
      [theme.breakpoints.up('lg')]: {
        height: pxToRem(48),
        width: pxToRem(65),
      },
    },
  },
}));

export default useStyles;
